import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconScrollBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none">
				<path
					fill="#000"
					d="M12.56 9.382a.29.29 0 0 1 .414.004l.203.21.435.45.362.372c2.077 2.134 3.557 3.583 4.537 4.472l.094.085c.314.282.55.48.715.609l.049.037.064.047.032.021.005.004.017.01a.303.303 0 0 1 .113.384.29.29 0 0 1-.39.141l-.019-.01c-.135-.073-.444-.316-1.038-.853l-.092-.084c-.99-.902-2.46-2.343-4.502-4.44l-.476-.49-.526-.546a.304.304 0 0 1 .003-.423m-2.878 2.771a.29.29 0 0 1 .414-.002l.14.141.583.596.355.365c2.039 2.1 3.447 3.627 4.338 4.673l.09.106q.38.451.587.727l.03.042c.1.134.153.216.176.26a.3.3 0 0 1-.117.405.29.29 0 0 1-.39-.108l-.009-.015-.015-.024-.026-.038-.057-.081-.028-.039a16 16 0 0 0-.652-.808l-.14-.164c-.897-1.042-2.285-2.54-4.265-4.58l-.367-.376q-.336-.344-.645-.658a.304.304 0 0 1-.002-.422"
				/>
				<path
					fill="#000"
					d="M19.13 15.745a.29.29 0 0 1 .415.001c.307.317.47.865.43 1.449a2.85 2.85 0 0 1-.84 1.812c-1.018 1.033-2.225 1.25-3.173.435a.304.304 0 0 1-.036-.421.29.29 0 0 1 .412-.037c.687.59 1.562.434 2.385-.401.413-.42.635-.924.669-1.43.027-.413-.08-.784-.25-.972l-.013-.013a.304.304 0 0 1 .002-.423z"
				/>
				<path
					fill="#E42822"
					d="M12.634 9.221c.712-.185 1.356-.071 1.773.358.819.842.413 2.508-.812 3.752s-2.858 1.646-3.677.804c-.41-.422-.52-1.067-.347-1.78a.29.29 0 0 1 .355-.218.3.3 0 0 1 .213.362c-.128.527-.055.959.194 1.215.536.55 1.824.233 2.85-.808 1.025-1.04 1.345-2.354.809-2.905-.254-.26-.686-.337-1.214-.2a.29.29 0 0 1-.356-.216.3.3 0 0 1 .212-.364"
				/>
				<path
					fill="#E42822"
					d="M14.25 9.387h.014l.04.002.175.013.112.009.039.003c.23.019.46.04.678.064l.093.01c.534.061.907.126 1.102.209.585.25.911.72.684 1.243-.22.505-.773.608-1.34.366-.18-.077-.456-.274-.827-.575l-.03-.026a18 18 0 0 1-.59-.498l-.092-.081-.121-.108-.121-.109-.012-.01-.01-.012-.01-.011-.026-.038L14 9.825l-.007-.014-.006-.014-.007-.019-.004-.013a.3.3 0 0 1-.01-.07v-.028l.002-.015.002-.015.003-.015.003-.014.004-.014.005-.015.004-.008.005-.013.006-.012.007-.012.007-.011.015-.022.011-.014.01-.011.012-.011.011-.01a.3.3 0 0 1 .05-.034l.013-.007.008-.003.012-.005.013-.005.013-.004.013-.003.04-.006zm.891.674.09.076.083.068.04.033c.34.277.603.467.718.516.309.131.515.093.58-.057.062-.144-.054-.311-.374-.448-.123-.052-.47-.113-.942-.166l-.12-.014z"
				/>
				<path
					fill="#E42822"
					d="M13.147 6.757c.517-.223.97.119 1.205.72.077.2.135.582.185 1.127.023.252.043.521.06.79l.011.19.009.17v.029l-.005.042-.003.013-.003.014-.005.013-.004.013-.005.012-.005.011a.3.3 0 0 1-.031.05l-.01.012-.01.01-.01.012-.014.012-.01.009-.01.008-.013.008-.013.008-.015.007-.006.004-.013.005-.018.007-.014.004-.014.003-.006.002-.014.002-.014.002h-.008l-.014.001h-.02l-.014-.001-.014-.002-.013-.002-.013-.003-.014-.004-.012-.004-.013-.005-.012-.005-.011-.005a.3.3 0 0 1-.049-.031l-.011-.01-.011-.01-.005-.005-.01-.01-.008-.01-.102-.123-.076-.092-.027-.033c-.154-.19-.31-.384-.454-.572l-.067-.088-.081-.108c-.276-.369-.457-.643-.527-.824-.227-.584-.117-1.147.381-1.363m.66.94c-.128-.33-.29-.45-.432-.389-.147.064-.188.274-.065.591.046.119.228.391.494.744l.064.084.033.043.07.091-.008-.108-.015-.157c-.043-.449-.094-.778-.14-.898z"
				/>
				<path
					fill="#000"
					d="M8.427 4.794c.123-.1.3-.082.401.037l.061.077.067.082.08.098.095.113q.26.311.637.74l.153.174c.857.966 1.972 2.163 3.377 3.608a.304.304 0 0 1-.001.423.29.29 0 0 1-.414-.002l-.261-.269a106 106 0 0 1-3.213-3.447L9.26 6.26a38 38 0 0 1-.625-.73l-.09-.108-.076-.094-.078-.098a.303.303 0 0 1 .035-.437zM4.795 7.535a.29.29 0 0 1 .403-.01l.017.016c.07.064.723.627 1.201 1.058l.148.135c1.005.915 2.249 2.115 3.831 3.72a.304.304 0 0 1 .002.423.29.29 0 0 1-.414.001l-.295-.298a98 98 0 0 0-3.475-3.365l-.185-.168c-.483-.435-1.189-1.043-1.234-1.09a.304.304 0 0 1 .001-.422"
				/>
				<path
					fill="#000"
					d="M8.48 4.76a.29.29 0 0 1 .391.137c.364.757.126 1.897-.61 2.642-1.084 1.101-2.46 1.285-3.448.437a.304.304 0 0 1-.035-.421.29.29 0 0 1 .412-.037c.737.633 1.775.494 2.66-.403.555-.564.739-1.414.506-1.933l-.01-.021a.3.3 0 0 1 .134-.4z"
				/>
				<path
					fill="#000"
					d="M4.777 4.813c.803-.815 2.095-.993 2.693-.377a.304.304 0 0 1-.001.422.29.29 0 0 1-.403.01l-.011-.011c-.341-.351-1.27-.223-1.865.38-.701.712-.739 1.52.02 2.3a.304.304 0 0 1-.002.422.29.29 0 0 1-.414-.001c-.995-1.023-.94-2.208-.017-3.145"
				/>
				<path
					fill="#000"
					d="M7.091 4.478a.29.29 0 0 1 .414.002c.574.59.55 1.649-.052 2.26-.634.643-1.42.788-1.971.222-.553-.569-.106-1.567.745-1.693.16-.024.308.09.332.253a.3.3 0 0 1-.234.337l-.014.002c-.408.06-.6.488-.414.68.283.29.713.21 1.144-.226.376-.381.391-1.062.049-1.414a.304.304 0 0 1 .001-.423"
				/>
			</g>
		</svg>
	);
}
